// @flow

import React from 'react'
import classNames from 'classnames'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import Carousel from '../../../components/basic/Carousel'
import baseStyles from './CaseReviews.scss'

type Props = {
  ...StyleProps,
  reviews: Array<Object>
}

const CaseReviews = ({ styles, reviews }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <Container className={styles.root} fluid>
      <Carousel
        styles={styles.slider}
        settings={{
          swipe: true,
          lazyLoad: 'progressive',
          infinite: true,
          dots: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1439,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                swipe: true
              }
            },
            {
              breakpoint: 9999,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                swipe: false
              }
            }
          ]
        }}
      >
        {reviews.map((item, i) => {
          return (
            <div className={styles.slide} key={'review' + i}>
              <div className={styles.review}>
                <div className={styles.header}>
                  <div className={styles.slideImg}>{item.img}</div>
                  <div className={styles.slideMeta}>
                    <div className={styles.name}>{item.name}</div>
                    <div className={styles.from}>{item.from}</div>
                    <div className={styles.rating}>
                      {item.rating.map((rate, j) => {
                        return (
                          <div key={'review' + i + j} className={classNames(styles.ratingStar, 'icon-star-filled')} />
                        )
                      })}
                    </div>
                  </div>
                </div>
                <h3 className={styles.title}>{item.titleId ? formatMessage(item.titleId) : item.title}</h3>
                <div className={styles.text}>{item.textId ? formatMessage(item.textId) : item.text}</div>
              </div>
            </div>
          )
        })}
      </Carousel>
    </Container>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseReviews)
